module.exports = __webpack_public_path__ + "static/media/ic_setatabela.45747922.svg";